import React from 'react'
import { withIcon } from '../../withIcon'

interface EyeOutlineIconProps {
  size?: string
  color?: string
}

function EyeOutlineIcon (props: EyeOutlineIconProps) {
  const {
    size = '16px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <g transform="translate(0.25 3.25)">
        <path d="M0.937635 5.15753C0.840795 5.03431 0.792375 4.9727 0.76527 4.87767C0.74491 4.80629 0.74491 4.69371 0.76527 4.62233C0.792375 4.5273 0.840795 4.46569 0.937635 4.34247C1.73789 3.32419 4.11992 0.75 7.75 0.75C11.3801 0.75 13.7621 3.32419 14.5624 4.34247C14.6592 4.46569 14.7076 4.5273 14.7347 4.62233C14.7551 4.69371 14.7551 4.80629 14.7347 4.87767C14.7076 4.9727 14.6592 5.03431 14.5624 5.15753C13.7621 6.17581 11.3801 8.75 7.75 8.75C4.11992 8.75 1.73789 6.17581 0.937635 5.15753Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.75 6.46429C8.92816 6.46429 9.88325 5.69677 9.88325 4.75C9.88325 3.80323 8.92816 3.03571 7.75 3.03571C6.57184 3.03571 5.61675 3.80323 5.61675 4.75C5.61675 5.69677 6.57184 6.46429 7.75 6.46429Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  )
}

export default withIcon(EyeOutlineIcon)
